import { useQuery } from 'react-query';
import { getManagerV2 } from 'client/UserProfile';
import userManagerKeys from 'src/consts/queryKeys/userManagerKeys';
export const useGetUserManager = (placementId, options) => {
    const fetchManager = () => {
        return getManagerV2(placementId);
    };
    return useQuery(userManagerKeys.userManager(placementId), () => fetchManager(), { ...options, cacheTime: Infinity, staleTime: 1000 * 360 });
};
